var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCarroceria(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 18.97 15.909 L 15.701 15.909 L 15.701 18.088 L 18.97 18.088 L 18.97 15.909 M 22.238 23.536 L 1.538 23.536 L 1.538 12.641 L 10.254 3.925 L 21.149 3.925 C 21.75 3.925 22.238 4.413 22.238 5.014 L 22.238 23.536 M 11.158 6.104 L 4.621 12.641 L 20.059 12.641 L 20.059 6.104 L 11.158 6.104 Z",
    style: {}
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarroceria);
export default __webpack_public_path__ + "static/media/iconCarroceria.97cdb618e8fa3e6f062d30ab0d5b47db.svg";
export { ForwardRef as ReactComponent };